export type EventDetailSection = {
  heading: string;
  body: string[];
};

export type EventItem = {
  id: string;
  /** 카드·상세 제목 */
  title: string;
  /** 카드 상단 뱃지(혜택 성격) */
  badge: string;
  /** 카드·상세 한 줄 요약 */
  summary: string;
  /** 진행 기간 표기 */
  period: string;
  thumbnail: string;
  poster: string;
  /** <title> */
  seoTitle: string;
  /** meta description */
  seoDescription: string;
  /** 상세 도입 문단 */
  intro: string;
  sections: EventDetailSection[];
  /** 유의사항 */
  notes: string[];
};

const IMG = '/assets/img/events';

export const EVENTS: EventItem[] = [
  {
    id: 'revisit-coffee',
    title: '재방문 커피',
    badge: '재방문 고객 혜택',
    summary: '다시 오면 무료 커피 1잔',
    period: '상시',
    thumbnail: `${IMG}/jejuro_event_coffee_thumb.jpg`,
    poster: `${IMG}/jejuro_event_coffee_poster.jpg`,
    seoTitle: '재방문 고객 무료 커피 이벤트 | 제주로렌트카',
    seoDescription:
      '제주로렌트카를 다시 찾아주신 고객님께 무료 커피 1잔을 드립니다. 제주공항 렌트카 재방문 혜택으로 제주 여행을 더 따뜻하게 시작하세요.',
    intro:
      '제주로렌트카를 다시 찾아주신 고객님께 감사의 마음을 담아 무료 커피 1잔을 드립니다. 제주공항에서 제주도 렌트카를 인수하실 때, 재방문 고객이라면 누구나 받으실 수 있는 상시 혜택입니다.',
    sections: [
      {
        heading: '이런 분께 드려요',
        body: [
          '제주로렌트카에서 이전에 차량을 대여하신 재방문 고객님',
          '이번 제주 여행에서도 제주로렌트카로 렌트카를 예약하신 고객님',
        ],
      },
      {
        heading: '받는 방법',
        body: [
          '별도 신청 없이, 차량 인수 시 전산에서 재방문 이력이 확인되면 무료 커피 1잔 쿠폰을 드립니다.',
          '무인 키오스크 옆 커피 머신에서 따뜻한 커피 한 잔으로 여행을 시작하세요.',
        ],
      },
    ],
    notes: [
      '전산에서 재방문 확인 후 혜택이 제공됩니다.',
      '커피 1잔은 1회 대여당 1개 제공되며, 소진 시 조기 종료될 수 있습니다.',
      '본 혜택은 제주로렌트카 사정에 따라 변경될 수 있습니다.',
    ],
  },
  /* [숨김] 쿠폰코드 이벤트 — 복구 시 아래 블록 주석 해제
  {
    id: 'fuel-coupon',
    title: '쿠폰코드 혜택',
    badge: '제주에디 유튜브 코드',
    summary: '코드 입력하고 특별한 혜택 받기',
    period: '상시',
    thumbnail: `${IMG}/jejuro_event_coupon_thumb.jpg`,
    poster: `${IMG}/jejuro_event_coupon_poster.jpg`,
    seoTitle: '쿠폰코드 혜택 이벤트 | 제주로렌트카',
    seoDescription:
      '제주로렌트카 쿠폰코드 이벤트. 제주에디 유튜브에서 쿠폰코드를 확인하고 예약 시 입력하면, 이용 후 특별한 혜택을 드립니다. 결제 금액 변동 없이 제주공항 렌트카를 이용하세요.',
    intro:
      '제주에디 유튜브에서 안내하는 쿠폰코드를 예약 시 입력하면, 차량 이용 후 특별한 혜택을 보내드립니다. 결제 금액은 그대로이며, 이용을 마치신 뒤 담당자가 혜택을 전송해드리는 상시 이벤트입니다.',
    sections: [
      {
        heading: '받는 방법',
        body: [
          '쿠폰코드는 제주에디 유튜브 채널에서 확인하세요.',
          '예약 결제 단계에서 쿠폰코드를 입력하세요.',
          '차량 반납(이용 완료) 후 담당자가 혜택을 보내드립니다.',
        ],
      },
      {
        heading: '안내',
        body: [
          '쿠폰코드를 입력해도 결제 금액은 변동되지 않습니다.',
          '혜택은 반납 확인 후 지급됩니다.',
        ],
      },
    ],
    notes: [
      '쿠폰코드는 제주에디 유튜브에서 안내한 코드에 한해 적용됩니다.',
      '혜택은 반납 후 담당자가 개별 전송합니다.',
      '본 혜택은 제주로렌트카 사정에 따라 변경될 수 있습니다.',
    ],
  },
  */
  {
    id: 'use-mileage',
    title: '마일리지 사용',
    badge: '보유 리워드 사용',
    summary: '쌓은 혜택 바로 사용',
    period: '상시',
    thumbnail: `${IMG}/jejuro_event_mileage_thumb.jpg`,
    poster: `${IMG}/jejuro_event_mileage_poster.jpg`,
    seoTitle: '마일리지 사용 안내 | 제주로렌트카',
    seoDescription:
      '제주로렌트카에서 쌓은 마일리지로 더 가볍게 결제하세요. 재방문·친구 초대로 적립한 리워드를 제주공항 렌트카 예약 결제에 바로 사용할 수 있습니다.',
    intro:
      '재방문·친구 초대 등으로 쌓아둔 마일리지를 제주로렌트카 예약 결제에 바로 사용하세요. 제주도 렌트카를 더 가볍게 이용할 수 있는 상시 혜택입니다.',
    sections: [
      {
        heading: '이렇게 사용해요',
        body: [
          '보유한 마일리지(리워드)를 결제 단계에서 바로 사용할 수 있습니다.',
          '쌓아둔 마일리지만큼 제주공항 렌트카 예약 금액을 할인받습니다.',
        ],
      },
      {
        heading: '마일리지 쌓는 방법',
        body: [
          '제주로렌트카 이용 시 적립되는 재방문·친구 초대 리워드로 마일리지가 쌓입니다.',
          '내 마일리지 잔액은 마이페이지에서 확인할 수 있습니다.',
        ],
      },
    ],
    notes: [
      '마일리지는 결제 시점의 보유 잔액 내에서 사용할 수 있습니다.',
      '사용 조건·한도는 제주로렌트카 정책에 따릅니다.',
      '본 혜택은 제주로렌트카 사정에 따라 변경될 수 있습니다.',
    ],
  },
  {
    id: 'invite-friend',
    title: '친구 초대',
    badge: '함께 받는 리워드',
    summary: '초대하고 함께 혜택 받기',
    period: '상시',
    thumbnail: `${IMG}/jejuro_event_friend_thumb.jpg`,
    poster: `${IMG}/jejuro_event_friend_poster.jpg`,
    seoTitle: '친구 초대 리워드 이벤트 | 제주로렌트카',
    seoDescription:
      '제주로렌트카 친구 초대 이벤트. 친구를 초대하면 친구도 나도 리워드를 받고, 초대할수록 더 큰 혜택이 쌓입니다. 제주도 렌트카 예약 전 초대하고 함께 받으세요.',
    intro:
      '제주로렌트카를 친구에게 소개하고 함께 혜택을 받으세요. 친구가 내 초대로 제주공항 렌트카를 예약하면, 친구도 나도 리워드를 받는 상시 이벤트입니다. 제주도 렌트카를 자주 이용하는 분일수록 더 크게 쌓입니다.',
    sections: [
      {
        heading: '초대 혜택',
        body: [
          '초대할 때마다 리워드가 적립됩니다.',
          '친구도, 나도 함께 혜택을 받습니다.',
          '더 많이 초대할수록 더 큰 혜택으로 돌아옵니다.',
        ],
      },
      {
        heading: '참여 방법',
        body: [
          '내 초대 링크를 친구에게 공유하세요.',
          '친구가 초대 링크로 가입해 제주로렌트카에서 렌트카를 예약하면 리워드가 지급됩니다.',
        ],
      },
    ],
    notes: [
      '적립된 리워드(마일리지)는 결제 시 사용할 수 있습니다.',
      '부정 적립이 확인되면 리워드가 회수될 수 있습니다.',
      '본 혜택은 제주로렌트카 사정에 따라 변경될 수 있습니다.',
    ],
  },
];

export const getEventById = (id: string): EventItem | undefined =>
  EVENTS.find((event) => event.id === id);
